module.exports = __webpack_public_path__ + "static/beholder-f3089621633ee82e9c0e2c82d3fc02b5.webp";